import React, {Component} from 'react';

import CookieWrapper from '../styled-components/CookieWrapper';

const allowAnalytics = () => {
  if('GTM-TJDFWH' !== '') {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-TJDFWH');

    var noScript = document.createElement("noscript");
    var iframe = document.createElement("iframe");
    (document.getElementsByTagName( "body" )[ 0 ]).appendChild( noScript );
    (document.getElementsByTagName( "noscript" )[ 0 ]).appendChild( iframe );
    iframe.src="https://www.googletagmanager.com/ns.html?id=" + 'GTM-TJDFWH';
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
  }
}

const allowCookies = (opa) => {
  allowAnalytics();
  localStorage.setItem('allowCookies-' + 'GTM-TJDFWH', true);
  opa;
}

const notAllowCookies = (opa) => {
  localStorage.setItem('allowCookies-' + 'GTM-TJDFWH', false);
  opa;
}

class Cookie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCookie: false
    };
  }

  componentDidMount() {
    var cookiesAllowed = localStorage.getItem('allowCookies-' + 'GTM-TJDFWH');

    if(!cookiesAllowed) {
      this.setState({
        showCookie: true
      })
    }

    if(cookiesAllowed === 'true') {
      allowCookies();
      this.setState({
        showCookie: false
      })
    }
    if(cookiesAllowed === 'false') {
      notAllowCookies();
      this.setState({
        showCookie: false
      })
    }
  };

  render() {
    return (
      <CookieWrapper id="cookie-eu" className="cookie-eu" style={this.state.showCookie ? {display: 'flex'} : {display: 'none'}}>
        <main>
          <h3>This website uses cookies to ensure you the best experience on our website. <a href="//www.rhei.com/privacy-policy" target="_blank">Learn more</a></h3>
        </main>
        <aside>
          <button onClick={() => notAllowCookies(this.setState({
            showCookie: false
          }))} className="transparent" style={{}}>Decline</button>
          <button onClick={() => allowCookies(this.setState({
            showCookie: false
          }))}>Accept</button>
        </aside>
      </CookieWrapper>
    )
  }
}

export default Cookie



// WEBPACK FOOTER //
// ./src/components/Cookie.js